import { render, staticRenderFns } from "./ImgButton.vue?vue&type=template&id=c1542f1e&"
import script from "./ImgButton.vue?vue&type=script&lang=js&"
export * from "./ImgButton.vue?vue&type=script&lang=js&"
import style0 from "./ImgButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports